import moment from 'moment';

export const filterByUserEndDate = (c, selectedMonth) => {
	const endOfMonthTimestamp = moment
		.utc(selectedMonth.value)
		.endOf('month')
		.valueOf();

	const rawEndDate = c._user?.contract_end_date;

	if (rawEndDate) {
		const userEndDateTimestamp = moment
			.utc(rawEndDate)
			.endOf('month')
			.valueOf();

		if (userEndDateTimestamp < endOfMonthTimestamp) {
			return false;
		}
	}

	return true;
};
